export default "__VITE_ASSET__Dx1JL87d__"